/* eslint-disable no-unused-vars */
import { Message } from 'element-ui'
import { enumObj } from '@/api/enum'
import {
    getProvince,
    getCity,
    getRegion,
    getDirctItem,
    querySubCompany,
    queryPharmacy,
    queryClassify,
    getBrand,
    queryManufacturers,
    queryManufacturersCard,
    queryTabooList,
    querySymptomList,
    queryTypeItem,
    getDeliveryList,
    activityTabs
} from '@/api/common'
import { shopClassification } from '@/api/shop'
// promotion 促销
const enums = {
    state: {
        ...enumObj,
        province: [],
        city: [],
        region: [],
        directObj: {
            type1: [],
            type2: [],
            type14: [],
            type15: [],
            type16: [],
            type21: [],
            type17: [],
            type18: [],
            type19: [],
            type22: [],
            type24: [],
            type25: [],
            type26: [],
            type29: [],
            type36: [],
            type41: [],
            type42: [],
            type43: [],
            type44: [],
            type45: [],
            type59: []
        },
        subCompany: [], // 子公司
        pharmacy: [], // 门店
        firstClassify: [],
        brand: [], // 品牌
        queryBrand: [], // 查询品牌
        manufacturers: [],
        manufacturersCard: [], // 生产企业许可证号
        taboo: [], // 服用禁忌列表
        symptomList: [], // 疾病列表
        typeItem: [], // 列表子项--医疗器械模板
        delivery: [], // 物流商列表
        activityTabs: [] // 拼团标签
    },
    mutations: {
        SET_XX_ENUM: (state, payload) => {
            state.promotion.status = payload
        },
        // 获取省份列表
        SET_PROVINCE_ENUM(state, payload) {
            state.province = null
            state.province = []
            state.province = JSON.parse(JSON.stringify(payload))
        },
        // 根据省份id获取城市列表 getRegion
        SET_CITY_ENUM: (state, payload) => {
            state.city = null
            state.city = payload
        },
        // 根据城市id获取区县列表
        SET_REGION_ENUM: (state, payload) => {
            state.region = null
            state.region = payload
        },

        SET_DIRECT: (state, payload) => {
            state.directObj[payload.key] = null
            state.directObj[payload.key] = payload.value
        },
        // 子公司列表
        SET_SUB_COMPANY: (state, payload) => {
            state.subCompany = null
            state.subCompany = payload
        },
        // 获取门店
        SET_PHARMACY: (state, payload) => {
            state.pharmacy = null
            state.pharmacy = payload
        },
        // 获取初始一级分类
        SET_FIRST_CLASS: (state, payload) => {
            state.firstClassify = null
            state.firstClassify = payload
        },
        // 获取品牌
        SET_BRAND: (state, payload) => {
            state.brand = null
            state.brand = payload
        },
        // 获取品牌
        SET_QUERY_BRAND: (state, payload) => {
            state.queryBrand = null
            state.queryBrand = payload
        },
        // 获取生产企业
        SET_MANU: (state, payload) => {
            state.manufacturers = null
            state.manufacturers = payload
        },

        SET_MANU_CARD: (state, payload) => {
            state.manufacturersCard = null
            state.manufacturersCard = payload
        },
        // 服用禁忌列表
        SET_TABOO: (state, payload) => {
            state.taboo = null
            state.taboo = payload
        },

        SET_SYMPTOM: (state, payload) => {
            state.symptomList = null
            state.symptomList = payload
        },
        // 医疗器械--类别子项
        SET_TYPE_ITEM: (state, payload) => {
            state.typeItem = null
            state.typeItem = payload
        },
        // 获取店铺分类下拉列表
        SET_SHOP_CLASSIFICATION: (state, payload) => {
            state.shopClassification = null
            state.shopClassification = payload
        },
        // 物流商列表
        SET_DELIVERY: (state, payload) => {
            state.delivery = null
            state.delivery = payload
        },
        // 拼团标签
        SET_ACTIVITY_TABS: (state, payload) => {
            state.activityTabs = null
            state.activityTabs = payload
        }
    },
    actions: {
        // 获取字典表
        async GetEnum({ commit }, types) {
            const res = await getDirctItem({
                types
            })
            if (res.code == 0) {
                // 改变id类型 和详情返回的id类型对应  储存条件
                if (types === 26)
                    res.data = res.data.map(item => ({
                        defineId: item.defineId + '',
                        name: item.name
                    }))
                // 改变id类型 和详情返回的id类型对应  药品分类
                if (types === 29)
                    res.data = res.data.map(item => ({
                        defineId: item.defineId + '',
                        name: item.name
                    }))

                commit('SET_DIRECT', {
                    key: `type${types}`,
                    value: res.data
                })
            } else {
                Message.error(res.msg || '请求失败')
            }
        },
        // 获取省份列表
        async GetProvince({ commit }, params) {
            const { code, data, msg } = await getProvince(params)
            if (+code === 0) {
                commit('SET_PROVINCE_ENUM', data)
            } else {
                Message.error(msg || '请求失败')
            }
        },
        // 根据省份id获取城市列表
        async GetCity({ commit }, provinceId) {
            const { code, data, msg } = await getCity({
                provinceId
            })
            if (+code === 0) {
                commit('SET_CITY_ENUM', data)
            } else {
                Message.error(msg || '请求失败')
            }
        },
        // 根据省份id获取城市列表
        async GetRegion({ commit }, cityId) {
            const { code, data, msg } = await getRegion({
                cityId
            })
            if (+code === 0) {
                commit('SET_REGION_ENUM', data)
            } else {
                Message.error(msg || '请求失败')
            }
        },
        // 查询当前商家下子公司列表
        GetSubCompany({ commit }, params) {
            querySubCompany(params).then(res => {
                if (res.code === 0) {
                    commit('SET_SUB_COMPANY', res.data)
                } else {
                    Message.error(res.msg || '请求失败')
                }
            })
        },
        // 查询当前商家下门店列表
        GetPharmacy({ commit }, params) {
            // 获取当前商家下门店
            queryPharmacy(params).then(res => {
                if (+res.code === 0) {
                    commit('SET_PHARMACY', res.data)
                } else {
                    Message.error(res.msg || '请求失败')
                }
            })
        },
        // 获取初始一级分类
        GetFirstClass({ commit }, params = {}) {
            queryClassify(params).then(res => {
                if (+res.code === 0) {
                    commit('SET_FIRST_CLASS', res.data)
                } else {
                    Message.error(res.msg || '请求失败')
                }
            })
        },
        // 获取品牌
        async GetBrand({ commit }, params) {
            const res = await getBrand(params)
            if (res.code === 0) {
                commit('SET_BRAND', res.data)
            } else {
                Message.error(res.msg || '请求失败')
            }
        },
        // 获取品牌
        async GetQueryBrand({ commit }, params) {
            if (params.name === '') return
            const res = await getBrand(params)
            if (+res.code === 0) {
                commit('SET_QUERY_BRAND', res.data)
                return res.data
            } else {
                Message.error(res.msg || '请求失败')
                return []
            }
        },
        // 获取生产厂商
        async GetManufacturers({ commit }, params) {
            const res = await queryManufacturers(params)
            if (res.code === 0) {
                commit('SET_MANU', res.data)
            } else {
                // Message.error(res.msg || '请求失败')
            }
        },
        // 生产企业许可证号
        async GetManufacturerCard({ commit }, params) {
            if (!params || (params && !params.mId)) {
                commit('SET_MANU_CARD', '')
                return
            }
            const res = await queryManufacturersCard(params)
            if (res.code === 0) {
                res.data = res.data.map(item => ({
                    id: item.id + '',
                    proLicenseCode: item.proLicenseCode
                }))
                commit('SET_MANU_CARD', res.data)
            } else {
                Message.error(res.msg || '请求失败')
            }
        },
        // 服用禁忌
        async GetTaboo({ commit }, params) {
            const res = await queryTabooList(params)
            if (res.code === 0) {
                const temp =
                    res.data &&
                    res.data.map(item => {
                        return {
                            id: item.id + '',
                            name: item.name
                        }
                    })
                commit('SET_TABOO', temp)
            } else {
                // Message.error(res.msg || '请求失败')
            }
        },

        // 获取疾病列表
        async GetSymptomList({ commit }, params) {
            const data = {
                ...params,
                page: 1,
                pageSize: 100
            }
            const res = await querySymptomList(data)
            if (res.code === 0) {
                commit('SET_SYMPTOM', res.data.list)
            }
        },

        // 类别子项
        async GetTypeItems({ commit }, params) {
            if (!params) {
                commit('SET_TYPE_ITEM', [])
                return
            }
            const res = await queryTypeItem(params)
            if (res.code === 0) {
                commit('SET_TYPE_ITEM', res.data)
            }
        },
        // 获取店铺分类下拉列表
        async GetShopClassification({ commit }, params) {
            const { code, data, msg } = await shopClassification(params)
            if (+code === 0) {
                const arr = Object.keys(data).map(key => {
                    return {
                        value: +key,
                        label: data[key]
                    }
                })
                commit('SET_SHOP_CLASSIFICATION', arr)
            } else {
                Message.error(msg || '请求失败')
            }
        },
        // 物流商列表
        async GetDeliveryList({ commit }, params) {
            const { code, data, msg } = await getDeliveryList(params)
            if (+code === 0) {
                const arr = data.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                })
                commit('SET_DELIVERY', arr)
            } else {
                Message.error(msg || '请求失败')
            }
        },
        //  拼团标签
        async GetActivityTabs({ commit }, params) {
            const { code, data, msg } = await activityTabs(params)
            if (+code === 0) {
                commit('SET_ACTIVITY_TABS', data)
            } else {
                Message.error(msg || '请求失败')
            }
        }
    }
}

export default enums
